import React, { useEffect, useMemo, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Grid,
  Box,
  Button,
  Typography,
  TextField,
  MenuItem,
  InputAdornment,
  Card,
} from "@mui/material";
import {
  useDeleteCategoryMutation,
  useGetAllCategoryNameQuery,
  useGetAllMainCategory2Query,
  useGetTaxQuery,
} from "../../../Api/attoDeskApi";
import { ICategory, ITaxes } from "../../../Api/Interface/api.interface";
import DeletePopup from "../../../Components/Delete/DeletePopup";
import { useNotifier } from "../../../Core/Notifier";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { Dayjs } from "dayjs";
import { RooleType } from "../../../Core/Enum/enum";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { useStyles } from "../../../theme/appStyles";
import AlertPopUp from "../../../Components/AlertPopUp/AlertPopup";
import useDebounce from "../../../Components/SearchDebonce/useDebounce";
import { useNavigate } from "react-router-dom";
import { CiSearch } from "react-icons/ci";
import NewPopUpCategory from "../Edit/index";
import DeleteOutlineSharpIcon from "@mui/icons-material/DeleteOutlineSharp";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import Pagination from "../../../Components/Pagination";
import CategoryIcon from "@mui/icons-material/Category";
import { toProperCase } from "../../../Components/Validation/toProperCase";
import { FcPicture } from "react-icons/fc";

const Index = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const getFormattedDate = (createDate: Dayjs | null): string => {
    return createDate ? createDate.format("YYYY-MM-DD") : "";
  };
  const { showErrorMessage, showMessage } = useNotifier();
  const [searchQuery, setSearchQuery] = useState("");
  const [currentSearchQuery, setCurrentSearchQuery] = useState("");
  const [selectedCoursingId, setSelectedCousingId] = useState<string>("");
  const [selectedProductTaxId, setSelectedProductTaxId] =
    useState<string>("All Tax");
  const [selectedProductRoles, setSelectedProducRoles] = useState<string[]>([]);
  const [selectedIsActive, setSelectedProductIsActive] = useState<string>("1");
  const [selectedIsLooping, setSelectedIsLooping] = useState<string>("");
  const debouncedSearchQuery = useDebounce(searchQuery, 300);
  const [selectedDepartment, setSelectedDepartment] = useState<string>("");
  const [startDate, setStartDate] = useState<Dayjs | null>(null);
  const [endDate, setEndDate] = useState<Dayjs | null>(null);
  const [createDate, setCreateDate] = useState<Dayjs | null>(null);
  const startDateAsDate = startDate?.toDate() || null;
  const endDateAsDate = endDate?.toDate() || null;
  const [isPaperVisible, setIsPaperVisible] = useState(false);

  const { data, isLoading, isError, refetch } = useGetAllMainCategory2Query({
    departmentId: selectedDepartment,
    coursingId: selectedCoursingId,
    roleId: selectedProductRoles,
    // taxeId: selectedProductTaxId,
    createdDateStart: startDateAsDate as Date,
    createdDateEnd: endDateAsDate as Date,
    searchText: currentSearchQuery,
    numberOfLength: null,
    isActive: selectedIsActive,
    categoryIsLooping: selectedIsLooping,
    createdDate: getFormattedDate(createDate),
    taxeId:
      selectedProductTaxId && selectedProductTaxId !== "All Tax"
        ? selectedProductTaxId
        : "",
  });
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [selectedCoursing, setSelectedCoursing] = useState<ICategory | null>(
    null
  );
  const [openDialog, setOpenDialog] = useState(false);
  const [openDeleteCategory, setOpenDeleteCategory] = useState(false);
  const [coursingToDelete, setCoursingToDelete] = useState<ICategory | null>(
    null
  );
  const [deleteAlert, setDeleteAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");

  const { data: categoryData, isLoading: categoryLoading } =
    useGetAllCategoryNameQuery();

  const { data: taxData, isLoading: taxLoading } = useGetTaxQuery({
    searchText: "",
  });

  const categoryList = useMemo(() => {
    return categoryData?.data as ICategory[];
  }, [categoryData?.data]);

  const taxList = useMemo(() => {
    return taxData?.data as ITaxes[];
  }, [taxData?.data]);

  const categoryMap = useMemo(() => {
    const map = new Map();
    categoryList?.forEach((printer) => {
      map.set(printer.id, printer.categoryName);
    });
    return map;
  }, [categoryList]);

  useEffect(() => {
    if (debouncedSearchQuery.length >= 4 || debouncedSearchQuery === "") {
      setCurrentSearchQuery(debouncedSearchQuery);
      refetch();
    }
  }, [debouncedSearchQuery]);

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleOpenDialog = (coursing: ICategory) => {
    setSelectedCoursing(coursing);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setSelectedCoursing(null);
    setOpenDialog(false);
  };

  const handleOpenDeletePopup = (coursing: ICategory) => {
    setCoursingToDelete(coursing);
    setOpenDeleteCategory(true);
  };

  const handleCloseDeletePopup = () => {
    setCoursingToDelete(null);
    setOpenDeleteCategory(false);
  };

  const handleCoursing = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedValues = event.target.value;
    setSelectedCousingId(selectedValues);
  };

  const handleDepartment = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedValues = event.target.value;
    setSelectedDepartment(selectedValues);
  };

  const handleProductTax = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedValues = event.target.value;
    setSelectedProductTaxId(selectedValues);
  };

  const handleProductIsActive = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const selectedValues = event.target.value;
    setSelectedProductIsActive(selectedValues);
  };

  const handleIsLooping = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedValues = event.target.value;
    setSelectedIsLooping(selectedValues);
  };

  const handleStartDateChange = (newValue: Dayjs | null) => {
    setStartDate(newValue);
  };

  const handleCreateDateChange = (newValue: Dayjs | null) => {
    setCreateDate(newValue);
  };

  const handleEndDateChange = (newValue: Dayjs | null) => {
    setEndDate(newValue);
  };

  const handleProductRoals = (event: React.ChangeEvent<HTMLInputElement>) => {
    const {
      target: { value },
    } = event;
    setSelectedProducRoles(
      typeof value === "string" ? value.split(",") : value
    );
  };

  const [deleteCategory] = useDeleteCategoryMutation();
  const handleDelete = async (id: string) => {
    try {
      const response = await deleteCategory(id).unwrap();
      if (response.status) {
        showMessage(response.message);
        setOpenDeleteCategory(false);
      } else {
        setAlertMessage(response.message);
        setDeleteAlert(true);
      }
    } catch (error) {
      showErrorMessage("Failed to delete the category");
    }
  };

  const handleToggle = () => {
    setIsPaperVisible(!isPaperVisible);
  };

  if (isLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  const coursings: ICategory[] = Array.isArray(data?.data)
    ? (data?.data as ICategory[])
    : [];

  const resetFields = () => {
    setSelectedDepartment("");
    setSelectedCousingId("");
    setSelectedProductTaxId("");
    setSelectedIsLooping("");
    setSelectedProducRoles([]);
    setStartDate(null);
    setEndDate(null);
    setSelectedProductIsActive("1");
    setCreateDate(null);
  };

  const handleAddProductClick = () => {
    navigate("/category/create");
  };

  if (categoryLoading || taxLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Card className={classes.card}>
      <Grid
        container
        justifyContent={"space-between"}
        spacing={5}
        sx={{ padding: 2 }}
        className={classes.titleGrid}
      >
        {/* <Grid item lg={4} md={4} sm={4} xs={4} pt={2} alignContent={"center"}>
          <Typography className={classes.cardTitle}>New Category</Typography>
        </Grid> */}
        <Grid
          item
          lg={12}
          md={12}
          sm={12}
          xs={12}
          sx={{ display: "flex", justifyContent: "flex-end" }}
        >
          <Grid
            container
            spacing={1}
            justifyContent="flex-end"
            sx={{
              display: "flex",
              justifyContent: {
                xs: "flex-start",
                md: "flex-end",
              },
            }}
          >
            <Grid item>
              <TextField
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <CiSearch className={classes.searchWidgetIcon} />
                    </InputAdornment>
                  ),
                  classes: {
                    root: classes.formControlList,
                  },
                }}
                fullWidth
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Category Name .."
                className={classes.searchTextField}
                size="small"
              />
            </Grid>
            <Grid item>
              <TextField
                select
                size="small"
                value={selectedIsActive || "1"}
                onChange={handleProductIsActive}
                sx={{ flexGrow: 1, width: "100%" }}
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  classes: {
                    root: classes.formControlListStatus,
                  },
                }}
                className={classes.searchTextField34}
              >
                <MenuItem value={"1"}>Active</MenuItem>
                <MenuItem value={"0"}>In Active</MenuItem>
              </TextField>
            </Grid>
            <Grid item>
              <Button
                variant="outlined"
                className={classes.addButton}
                onClick={handleToggle}
              >
                {isPaperVisible ? "Close Filter" : "Open Filter"}
              </Button>
            </Grid>
            <Grid item>
              <Button
                // variant="contained"
                className={classes.addNewButton}
                onClick={handleAddProductClick}
              >
                Add New
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {isPaperVisible && (
        <>
          <Grid container spacing={2} my={5} p={2}>
            <Grid item lg={2} md={3} sm={12} xs={12}>
              <Grid container>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Typography variant="subtitle1" className={classes.body2}>
                    Category Roles
                  </Typography>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <TextField
                    select
                    size="small"
                    SelectProps={{
                      multiple: true,
                      native: false,
                    }}
                    InputLabelProps={{ shrink: true }}
                    value={selectedProductRoles || ""}
                    onChange={handleProductRoals}
                    sx={{ flexGrow: 1, width: "100%" }}
                    InputProps={{
                      classes: {
                        root: classes.formControlListStatus,
                      },
                    }}
                    className={classes.searchTextField34}
                  >
                    {Object.entries(RooleType).map(([key, value], index) => (
                      <MenuItem key={index} value={value}>
                        {key}
                      </MenuItem>
                    ))}

                    <MenuItem value="" style={{ color: "gray" }}>
                      Select an option
                    </MenuItem>
                  </TextField>
                </Grid>
              </Grid>
            </Grid>
            <Grid item lg={2} md={3} sm={12} xs={12}>
              <Grid container>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Typography variant="subtitle1" className={classes.body2}>
                    Category Tax
                  </Typography>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <TextField
                    select
                    size="small"
                    sx={{ flexGrow: 1, width: "100%" }}
                    value={selectedProductTaxId || ""}
                    onChange={handleProductTax}
                    InputLabelProps={{ shrink: true }}
                    InputProps={{
                      classes: {
                        root: classes.formControlListStatus,
                      },
                    }}
                    className={classes.searchTextField34}
                  >
                    <MenuItem value={"All Tax"}>All Tax</MenuItem>
                    {taxList &&
                      taxList.map((tax) => (
                        <MenuItem key={tax.id} value={tax.id}>
                          {tax.taxName}
                        </MenuItem>
                      ))}
                  </TextField>
                </Grid>
              </Grid>
            </Grid>
            <Grid item lg={2} md={3} sm={12} xs={12}>
              <Grid container>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Typography variant="subtitle1" className={classes.body2}>
                    Looping
                  </Typography>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <TextField
                    select
                    size="small"
                    sx={{ flexGrow: 1, width: "100%" }}
                    value={selectedIsLooping || ""}
                    onChange={handleIsLooping}
                    InputLabelProps={{ shrink: true }}
                    InputProps={{
                      classes: {
                        root: classes.formControlListStatus,
                      },
                    }}
                    className={classes.searchTextField34}
                  >
                    <MenuItem value="" style={{ color: "gray" }}>
                      Select an option
                    </MenuItem>
                    <MenuItem value="1">Yes</MenuItem>
                    <MenuItem value="0">No</MenuItem>
                  </TextField>
                </Grid>
              </Grid>
            </Grid>
            <Grid item lg={2} md={3} sm={12} xs={12}>
              <Grid container>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Typography variant="subtitle1" className={classes.body2}>
                    Create Date
                  </Typography>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      onChange={handleCreateDateChange}
                      value={createDate}
                      className={classes.searchTextField34}
                      slotProps={{
                        textField: {
                          placeholder: "Create Date",
                          size: "small",
                          sx: {
                            width: "140px",
                          },
                          InputProps: {
                            sx: {
                              fontSize: 14,
                              // color: "#97c3df",
                            },
                            // classes: {
                            //   // root: classes.textFieldQuote,
                            // },
                            classes: {
                              root: classes.formControlListStatus,
                            },
                          },
                          InputLabelProps: {
                            sx: {
                              fontSize: 14,
                              // color: "#97c3df",
                            },
                          },
                        },
                      }}
                    />
                  </LocalizationProvider>
                </Grid>
              </Grid>
            </Grid>
            <Grid item lg={2} md={3} sm={12} xs={12}>
              <Grid container>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Typography variant="subtitle1" className={classes.body2}>
                    Start Date
                  </Typography>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      onChange={handleStartDateChange}
                      value={startDate}
                      className={classes.searchTextField34}
                      slotProps={{
                        textField: {
                          placeholder: "Start Date",
                          size: "small",
                          sx: {
                            width: "140px",
                          },
                          InputProps: {
                            sx: {
                              fontSize: 14,
                              // color: "#97c3df",
                            },
                            // classes: {
                            //   // root: classes.textFieldQuote,
                            // },
                            classes: {
                              root: classes.formControlListStatus,
                            },
                          },
                          InputLabelProps: {
                            sx: {
                              fontSize: 14,
                              // color: "#97c3df",
                            },
                          },
                        },
                      }}
                    />
                  </LocalizationProvider>
                </Grid>
              </Grid>
            </Grid>
            <Grid item lg={2} md={3} sm={12} xs={12}>
              <Grid container>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Typography variant="subtitle1" className={classes.body2}>
                    End Date
                  </Typography>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      onChange={handleEndDateChange}
                      value={endDate}
                      className={classes.searchTextField34}
                      slotProps={{
                        textField: {
                          placeholder: "End Date",
                          size: "small",
                          sx: {
                            width: "140px",
                          },
                          InputProps: {
                            sx: {
                              fontSize: 14,
                              // color: "#97c3df",
                            },
                            // classes: {
                            //   // root: classes.textFieldQuote,
                            // },
                            classes: {
                              root: classes.formControlListStatus,
                            },
                          },
                          InputLabelProps: {
                            sx: {
                              fontSize: 14,
                              // color: "#97c3df",
                            },
                          },
                        },
                      }}
                    />
                  </LocalizationProvider>
                </Grid>
              </Grid>
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Box display="flex" justifyContent="flex-end">
                <Button
                  variant="outlined"
                  startIcon={<RestartAltIcon />}
                  className={classes.addButton}
                  onClick={resetFields}
                >
                  Reset
                </Button>
              </Box>
            </Grid>
          </Grid>
        </>
      )}

      <Grid>
        <TableContainer>
          <Table className={classes.table}>
            <TableHead className={classes.tableHeaderRow}>
              <TableRow>
                <TableCell className={classes.tablheader}>
                  <strong>Category Name</strong>
                </TableCell>
                <TableCell
                  className={classes.tablheader}
                  // sx={{ textAlign: "center" }}
                >
                  <strong>Perent Category</strong>
                </TableCell>
                <TableCell
                  className={classes.tablheader}
                  // sx={{ textAlign: "center" }}
                >
                  <strong>Active</strong>
                </TableCell>
                <TableCell
                  className={classes.tablheader}
                  sx={{ textAlign: "right" }}
                >
                  <strong>Actions</strong>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {isError || coursings.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={20} align="center">
                    {isError ? "Error fetching data" : "No data available"}
                  </TableCell>
                </TableRow>
              ) : (
                coursings
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row: ICategory, index) => (
                    <TableRow key={row.id} className={classes.tableRowHover}>
                      <TableCell scope="row" className={classes.tablCell}>
                        <Grid container spacing={1}>
                          <Grid item>
                            <Grid container spacing={1}>
                              <Grid item>
                                <Box
                                  className={
                                    classes.SelectImageTableBoxwithBorder
                                  }
                                >
                                  {row.categoryImg ? (
                                    <img
                                      src={row.categoryImg}
                                      alt="img"
                                      // alt={row.variantName.toLowerCase()}
                                      className={classes.SelectImageTable}
                                    />
                                  ) : (
                                    <FcPicture
                                      className={classes.SelectImageTable}
                                    />
                                  )}
                                </Box>
                              </Grid>
                              <Grid
                                item
                                textAlign={"center"}
                                alignContent={"center"}
                              >
                                <Typography className={classes.nameTableList}>
                                  {toProperCase(row.categoryName)}
                                </Typography>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </TableCell>

                      <TableCell
                        scope="row"
                        className={classes.tablCell}
                        // sx={{ textAlign: "center" }}
                      >
                        {row.parent_ids
                          ?.map((id) => categoryMap.get(id) || " ")
                          .join(" → ")}
                      </TableCell>
                      <TableCell
                        scope="row"
                        className={classes.tablCell}
                        // sx={{ textAlign: "center" }}
                      >
                        {row.isActive ? "Active" : "Inactive"}
                      </TableCell>
                      <TableCell className={classes.tablCell}>
                        <Grid
                          container
                          spacing={1}
                          sx={{ display: "flex", justifyContent: "flex-end" }}
                        >
                          <Grid item>
                            <Button
                              // variant="contained"
                              className={classes.editButtonList}
                              onClick={() => handleOpenDialog(row)}
                            >
                              <EditSharpIcon className={classes.editListIcon} />
                            </Button>
                          </Grid>
                          <Grid item>
                            <Button
                              // variant="contained"
                              className={classes.deleteButtonList}
                              onClick={() => handleOpenDeletePopup(row)}
                            >
                              <DeleteOutlineSharpIcon
                                className={classes.deleteListIcon}
                              />
                            </Button>
                          </Grid>
                        </Grid>
                      </TableCell>
                    </TableRow>
                  ))
              )}
            </TableBody>
          </Table>
          <Grid
            spacing={5}
            p={"18px"}
            py={4}
            justifyContent={"end"}
            container
            textAlign={"center"}
            alignContent={"center"}
            alignItems={"center"}
          >
            <Grid
              sx={{
                textAlign: "end",
                justifyContent: "flex-end",
                alignItems: "flex-end",
              }}
            >
              <Pagination
                count={coursings.length}
                page={page}
                rowsPerPage={rowsPerPage}
                onPageChange={handleChangePage}
              />
            </Grid>
          </Grid>
        </TableContainer>
        {selectedCoursing && (
          <NewPopUpCategory
            openModel={openDialog}
            handleCloseDialog={handleCloseDialog}
            data={selectedCoursing}
          />
        )}
        {coursingToDelete && (
          <DeletePopup
            open={openDeleteCategory}
            handleCloseDelete={handleCloseDeletePopup}
            onConfirm={async () => {
              await handleDelete(coursingToDelete.id.toString());
            }}
            title="Delete Category"
            content={`Are you sure you want to delete "${coursingToDelete.categoryName}"?`}
          />
        )}

        <AlertPopUp
          open={deleteAlert}
          onCloseAlert={setDeleteAlert}
          message={alertMessage}
        />
      </Grid>
    </Card>
  );
};

export default Index;
